/**
 * CSV export.
 *
 * Two modes, and the difference matters enough that the UI names it:
 *  - the rows on screen, exported client-side, instant; and
 *  - every row matching the current filters, which needs the server (a 4,000
 *    row result cannot be assembled from a 20-row page).
 *
 * A "download" that silently gives you 20 of 4,000 rows is worse than no
 * export at all, so the caller must choose deliberately.
 */

/** RFC 4180 quoting: double the quotes, wrap anything with a separator. */
function cell(value: unknown): string {
  if (value === null || value === undefined) return '';
  const s = String(value);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function to_csv(headers: string[], rows: unknown[][]): string {
  const lines = [headers.map(cell).join(','), ...rows.map((r) => r.map(cell).join(','))];
  // CRLF + BOM: Excel on Windows is the actual destination for these files and
  // it reads a BOM-less UTF-8 CSV as Latin-1, which turns ₹ into â‚¹.
  return '\ufeff' + lines.join('\r\n');
}

export function download_csv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoking synchronously can cancel the download in Safari; a tick is enough.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** `users-2026-08-21.csv` — dated, so a folder of exports stays sortable. */
export function dated_filename(base: string): string {
  const d = new Date();
  const stamp = [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, '0'),
    String(d.getDate()).padStart(2, '0'),
  ].join('-');
  return `${base}-${stamp}.csv`;
}
